import Repository from '../axios'
import {defaultPagination} from "../constants/config";
import staff from "../apis/staff";

const  resource = "/admin/staff";
export default {
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getStaff(staffId){
    return Repository.get(`${resource}/${staffId}`)
  },
  createStaff(payload){
    return Repository.post(`${resource}`, payload)
  },
  updateStaff(staff_id, payload){
    return Repository.put(`${resource}/${staff_id}`, payload)
  },
  updateStaffPassword(payload){
    return Repository.post(`${resource}/change-password`, payload)
  }
};
